import { Box } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';

import { COLORS } from '../../../configs/colors';

const slaPulse = keyframes`
  0%, 100% { opacity: 1; filter: drop-shadow(0 0 0px transparent); }
  50% { opacity: 0.7; filter: drop-shadow(0 0 6px ${COLORS.SLABreached}); }
`;

export const CircleContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCritical',
})<{ isCritical?: boolean }>(({ isCritical }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  ...(isCritical && {
    animation: `${slaPulse} 1.5s ease-in-out infinite`,
  }),
}));

export const CircleSvg = styled('svg')({
  transform: 'rotate(-90deg)',
});

export const TimeText = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  fontWeight: 700,
  fontSize: '0.6rem',
  textAlign: 'center',
  lineHeight: 1.1,
  color: '#1a1a2e',
});
